import { PayloadAction } from '@reduxjs/toolkit';
import { AppBundle } from 'api/optimalprint-sdk.d';
import { CategoryState } from '../types';

const resetCategoryFiltersReducer = (
  state: CategoryState,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  action: PayloadAction<AppBundle.Api.Response.Category.V3.CategoryDesignsListV3Response.Filters | null | undefined>,
) => {
  state.filters = undefined;
};

export default resetCategoryFiltersReducer;
